import { mapGetters } from 'vuex';

// Единая ссылка «Поддержка»: всегда ведём в бота проекта, не в личный аккаунт.
// Дефолт приходит с бэка (config-data.php: support_link = t.me/<bot_username>),
// per-bot override — поле 'support_link' в bot-configs.php.
export default {
  computed: {
    ...mapGetters('app', ['configData']),
    supportLink() {
      const cfg = this.configData || {};
      if (cfg.support_link) return cfg.support_link;
      if (cfg.bot_username) return 'https://t.me/' + cfg.bot_username;
      return 'https://t.me/clipcut_bot';
    },
  },
};
